import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';
import { useHistory } from 'react-router-dom';

const ModalsCreate = ({
  showModalExit,
  errorModal,
  showModalDelete,
  setShowModalExit,
  setShowErrorModal,
  setShowModalDelete,
  deleteDraft
}) => {
  const history = useHistory();

  const showAccordionsWithError = (accordionsWithError) => accordionsWithError?.join(', ');

  return (
    <>
      {/* ALERTA DE CAMBIOS */}
      <ModalGeneric
        backdrop
        primaryAction={() => {
          history.goBack();
        }}
        primaryActionLabel="Aceptar"
        secondaryAction={() => setShowModalExit(false)}
        secondaryActionLabel="Cancelar"
        show={showModalExit}
        size="md"
      >
        <p>¿Desea salir? Podría perder los cambios si no fueron guardados</p>
      </ModalGeneric>

      {/* MODAL DE ERROR */}
      <ModalGeneric
        backdrop="static"
        infoModal
        onHide={() => {
          setShowErrorModal(false);
        }}
        primaryAction={() => {
          setShowErrorModal(false);
        }}
        primaryActionLabel="Aceptar"
        secondaryAction={() => {
          setShowErrorModal(false);
        }}
        secondaryActionLabel="Salir"
        show={errorModal.show}
        size="md"
        title="Sin supervisores cargados"
        variantHeader="warning"
      >
        <div className="modal_body_confirm">
          <p>
            Para poder asignar los servicios:{' '}
            <strong>{showAccordionsWithError(errorModal.accordionsWithError)}</strong> es necesario
            que <strong>selecciones al menos un Notificador (Supervisor YPF)</strong> en la sección
            COMUNICAR A
          </p>
          {/* <p>Para poder enviar y asignar la solicitud de servicio al proveedor {' '}
            <strong>
              {`${values?.provider?.providers[0]?.provider?.nombre} `}
            </strong> es necesario que {' '}
            <strong>
              selecciones al menos un Notificador (Supervisor YPF)
            </strong>
            en la sección COMUNICAR A.
          </p> */}
        </div>
      </ModalGeneric>

      {/* MODAL ELIMINAR BORRADOR */}
      <ModalGeneric
        backdrop
        primaryAction={deleteDraft}
        primaryActionLabel="Aceptar"
        secondaryAction={() => setShowModalDelete(false)}
        secondaryActionLabel="Cancelar"
        show={showModalDelete}
        size="md"
      >
        <p>¿Está seguro que desea eliminar esta solicitud de servicio?</p>
      </ModalGeneric>
    </>
  );
};

export default ModalsCreate;

ModalsCreate.propTypes = {
  showModalExit: PropTypes.bool,
  errorModal: PropTypes.shape({
    show: PropTypes.bool,
    accordionsWithError: PropTypes.arrayOf(PropTypes.string)
  }),
  showModalDelete: PropTypes.bool,
  setShowModalExit: PropTypes.func,
  setShowErrorModal: PropTypes.func,
  setShowModalDelete: PropTypes.func,
  deleteDraft: PropTypes.func
};

ModalsCreate.defaultProps = {
  showModalExit: false,
  errorModal: {
    show: false,
    accordionsWithError: []
  },
  showModalDelete: false,
  setShowModalExit: () => {
    /* EMPTY */
  },
  setShowErrorModal: () => {
    /* EMPTY */
  },
  setShowModalDelete: () => {
    /* EMPTY */
  },
  deleteDraft: () => {
    /* EMPTY */
  }
};
